/**
 * Event add_to_cart_clicked
 * ---
 * Notify Statsig when the `add to cart` or `proxy add to cart` button is clicked
 */

function run() {
  const client = window.Statsig.instance();
  const buttons = document.querySelectorAll(
    "[data-add-to-cart], [data-proxy-add-to-cart]"
  );

  buttons.forEach((button) => {
    button.addEventListener("click", function (event) {
      client.logEvent("add_to_cart_clicked");
    });
  });
}

if (window?.Statsig?.instance()?.loadingStatus === "Ready") {
  run();
} else {
  window.addEventListener("statsigReady", run);
}
